export default __webpack_public_path__ + "static/media/Spin torre RD_Interactive LightMix0026.2126c5c3.webp";